<header class="sticky top-0 z-50 bg-black shadow-md shadow-black/20">
  <nav class="mx-auto flex max-w-5xl items-center gap-4 justify-between p-4 lg:px-5" aria-label="Global">
    
    <div class="flex md:flex-1">
      <a routerLink="/" class="-m-1.5 p-1.5">
        <span class="sr-only">Dimers Platinum</span>
        <div class="relative h-10" style="width: 200px;">
            <div [ngClass]="{'opacity-0': isScrolled, 'opacity-100': !isScrolled}"
                class="absolute inset-0 flex items-center transition-opacity duration-300 ease-in-out">
                <img src="https://imgix.cosmicjs.com/f7c98b80-6612-11ef-80bb-ff60e40f80b5-Dimers-Platinum-Icon---Highlights.png?auto=format,compress&w=100"
                    alt="Dimers Platinum icon" width="30" height="30" loading="lazy">
            </div>
            <div [ngClass]="{'opacity-100': isScrolled, 'opacity-0': !isScrolled}"
                class="absolute inset-0 flex items-center transition-opacity duration-300 ease-in-out">
                 <img  
            src="https://imgix.cosmicjs.com/f1326170-6612-11ef-80bb-ff60e40f80b5-Dimers-Platinum-Logo---Highlights.png?auto=format,compress" alt="platinum" width="300" height="37" loading="lazy">
            </div>
        </div>
       
      </a>
    </div>

    
    <!-- <div class="flex items-center gap-4 md:hidden">
        <app-countdown-timer [isCard]="true" [isMobile]="true"></app-countdown-timer>
        <a
            [routerLink]="['/']" 
            [fragment]="'pricing'"
            class="px-2 h-8 flex items-center justify-center rounded whitespace-nowrap bg-turquoise text-sm font-medium text-gray-900">
            Get AI Picks
        </a>
    </div> -->

    <div class="flex md:hidden">
      <button 
        type="button" 
        (click)="toggleMobileMenu()" 
        class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400 hover:bg-gray-700/50">
        <span class="sr-only">Open main menu</span>
        <svg *ngIf="!isMobileMenuOpen" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>
        <svg *ngIf="isMobileMenuOpen" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
      </button>
    </div>

    <div class="hidden md:flex md:gap-x-8">
      <a *ngFor="let link of navLinks" 
         [routerLink]="link.path" 
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}"
         class="text-sm font-semibold leading-6 text-white hover:text-turquoise transition-colors">
        {{ link.label }}
      </a>
    </div>

  </nav>

  <div [ngClass]="{
      'opacity-100 translate-y-0': isMobileMenuOpen,
      'opacity-0 -translate-y-4 pointer-events-none': !isMobileMenuOpen
    }"
    class="md:hidden absolute left-0 w-full bg-black shadow-sm shadow-turquoise/10
           transition-all duration-300 ease-in-out "
    role="dialog" aria-modal="true">
    <div class="space-y-1 px-4 pb-4 pt-2">
      <a *ngFor="let link of navLinks" 
         [routerLink]="link.path"
         routerLinkActive="mobile active"
         [routerLinkActiveOptions]="{exact: true}"
         (click)="toggleMobileMenu()"
         class="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white">
        {{ link.label }}
      </a>
    </div>
  </div>
</header>